export default "__VITE_ASSET__98c98591__"